import React, { useEffect, useState } from "react";
import { Typography, Paper, Grid2 } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "../utils/Axios.ts";
import DynamicTab from "../components/extras/DynamicTab.tsx";
import ParentCard from "../components/ParentComponents/ParentCard.tsx";
import ParentTourListItemButton from "../components/ParentComponents/ParentTourListItemButton.tsx";
import LoadingSpinner from "../components/basics/LoadingSpinner.tsx";
import ErrorMessage from "../components/basics/ErrorMessage.tsx";

interface Parent {
  id: number;
  ready: boolean;
  bus_ready: boolean;
  guide_ready: boolean;
  agent: number;
  agent_name: string;
  name: string;
  booking_id: number;
  location: number;
  location_name: string;
  date: string;
  time_from: string;
  time_to: string;
  size: number;
  responsible: string;
  tourType: number;
  tourType_name: string;
  created_date: string;
  last_modified: string;
  created_by: string
  last_modified_by: string;
}

const HomePage: React.FC = () => {
  const [parents, setParents] = useState<Parent[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const navigate = useNavigate();


  const fetchParents = async () => {
    try {
      const response = await AxiosInstance.get(`/parent_next/`);

      if (response.status === 200) {
        const results = response.data || [];
        setParents(results);

        // If no tours, set an empty state message
        if (results.length === 0) {
          setError("No upcoming tours available.");
        } else {
          setError(null);
        }
      } else {
        throw new Error("Unexpected response status.");
      }
    } catch (error: any) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        navigate("/login");
      } else {
        setError(error.message || "Something went wrong");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchParents();
    // eslint-disable-next-line
  }, []);

  if (isLoading) return <LoadingSpinner />;
  if (error) return <ErrorMessage message={error} />;

  return (
    <DynamicTab title="IT Master" favicon="/logos/IT logo.png">
    <Grid2
      container
      spacing={2}
      direction="column"
      alignItems="center"
      style={{ maxWidth: "95%", margin: "auto" }}
    >
      <Paper
        style={{
          padding: "1%",
          width: "100%",
          maxWidth: "1300px",
          textAlign: "center",
        }}
      >
        <Typography variant="h6">Upcoming Tours</Typography>
      </Paper>
      <Paper style={{ padding: 0, width: "100%", maxWidth: "1300px" }}>
        <Grid2 container spacing={2} direction="column" alignItems="center">
          {parents.length > 0 ? (
            parents.map((parent) => (
              <Grid2 sx={{
                width: "100%",
              }} key={parent.id}>
                <ParentTourListItemButton parentId={parent.id}>
                  <ParentCard
                    id={parent.id}
                    name={parent.name}
                    location={parent.location_name || "Unknown Location"}
                    dateFrom={parent.date || "N/A"}
                    timeFrom={parent.time_from || "N/A"}
                    timeTo={parent.time_to || "N/A"}
                    bookingNum={parent.booking_id?.toString() || "N/A"}
                    agentName={parent.agent_name || "Unknown Agent"}
                    tourType={parent.tourType_name || "Unknown Tour Type"}
                  />
                </ParentTourListItemButton>
              </Grid2>
            ))
          ) : (
            <Typography variant="h6" style={{ textAlign: "center", padding: "2%" }}>
              No upcoming tours available.
            </Typography>
          )}
        </Grid2>
      </Paper>
    </Grid2>
    </DynamicTab>
  );
}

export default HomePage;
